import { render, staticRenderFns } from "./BuilderRegion.vue?vue&type=template&id=76a6aa31&"
import script from "./BuilderRegion.vue?vue&type=script&lang=js&"
export * from "./BuilderRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports